import React from "react";
import ProjectModel from "../../classes/models/ProjectModel";
import trackPathForAnalytics from "../analytics/TrackJobForAnalytics";
import AppButton from "./AppButton";

function ProBox(props: { model: ProjectModel }) {
  const model = props.model;

  function openProject() {
    trackPathForAnalytics({ action: "view_upwork_project", title: model.name });
    window.open(model.projectURL, "_blank");
  }

  return (
    <div className={`pro pro__1`}>
      <div className="pro__img">
        <img src={model.image} alt="website" />
      </div>
      <div className="pro__text">
        <h3>{model.name}</h3>
        <p>{model.description}</p>
        <div className="stack">
          {model.techstack.map((stack) => (
            <p>{stack}</p>
          ))}
        </div>
        <div>
          {model.projectURL && <AppButton callback={() => openProject()} />}
        </div>
      </div>
    </div>
  );
}

export default ProBox;
